import {takeEvery} from 'redux-saga/effects'

import {
  ADD_STUDENTS_TO_SPORT,
  CREATE_SPORTS_RECORD,
  DELETE_MANY_SPORTS_RECORDS,
  DELETE_SPORTS_RECORD,
  GET_AVAILABLE_STUDENTS,
  GET_SPORTS_RECORD,
  GET_SPORTS_RECORDS,
  GET_SPORT_STUDENTS,
  REMOVE_MANY_SPORTS_STUDENTS,
  REMOVE_STUDENT_FROM_SPORT,
  UPDATE_SPORTS_RECORD,
} from '../../../Actions/SportsRecord/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* sportsRecordSaga() {
  yield takeEvery(ADD_STUDENTS_TO_SPORT, fetchData)
  yield takeEvery(CREATE_SPORTS_RECORD, fetchData)
  yield takeEvery(DELETE_SPORTS_RECORD, fetchData)
  yield takeEvery(GET_AVAILABLE_STUDENTS, fetchData)
  yield takeEvery(GET_SPORTS_RECORD, fetchData)
  yield takeEvery(GET_SPORTS_RECORDS, fetchData)
  yield takeEvery(GET_SPORT_STUDENTS, fetchData)
  yield takeEvery(REMOVE_STUDENT_FROM_SPORT, fetchData)
  yield takeEvery(DELETE_MANY_SPORTS_RECORDS, fetchData)
  yield takeEvery(REMOVE_MANY_SPORTS_STUDENTS, fetchData)
  yield takeEvery(UPDATE_SPORTS_RECORD, fetchData)
}

export default sportsRecordSaga
